import { Chip } from '@mui/material';

/**
 * Visual status of a nomination based on its change-request counts.
 *
 * Precedence: any pending → "Changes requested"; rejected only → "Changes denied";
 * approved (with no pending) → "Changes approved"; otherwise → "Active".
 *
 * Lifted out of SubmitChange.tsx so EntrantHome and SubmitChange share one
 * component and one set of colour rules.
 */
export function CrStatusChip({ cr }: { cr: Record<string, number> | undefined | null }) {
  const counts = cr ?? {};
  const pending = counts.pending || 0;
  const approved = counts.approved || 0;
  const rejected = counts.rejected || 0;

  if (pending > 0) {
    return (
      <Chip
        size="small"
        label="Changes requested"
        sx={{
          backgroundColor: '#FEF3C7',
          color: '#92400E',
          fontWeight: 600,
          border: '1px solid #F59E0B',
        }}
      />
    );
  }
  if (rejected > 0 && approved === 0) {
    return (
      <Chip
        size="small"
        label="Changes denied"
        sx={{
          backgroundColor: '#FEE2E2',
          color: '#991B1B',
          fontWeight: 600,
          border: '1px solid #EF4444',
        }}
      />
    );
  }
  if (approved > 0) {
    return (
      <Chip
        size="small"
        label="Changes approved"
        sx={{
          backgroundColor: '#DCFCE7',
          color: '#166534',
          fontWeight: 600,
          border: '1px solid #22C55E',
        }}
      />
    );
  }
  return (
    <Chip
      size="small"
      label="Active"
      sx={{
        backgroundColor: '#ECFDF5',
        color: '#065F46',
        fontWeight: 600,
        border: '1px solid #6EE7B7',
      }}
    />
  );
}
